export default "__VITE_ASSET__C3wkhVOo__"